/**
 * localStorage key constants for ProductsRowGroupingDataGrid (Config C).
 * All localStorage access must use these constants — never inline strings.
 */

// --- Grouping ---
/** Current grouping dimension order */
export const STORAGE_KEY_GROUPING = 'lgm_products_grouping_model';
/** Active grouping preset key ('A' | 'B' | 'C' | 'CUSTOM' | `custom_${name}`) */
export const STORAGE_KEY_GROUPING_PRESET = 'lgm_products_active_preset';
/** User-saved grouping presets (old key — migrate to STORAGE_KEY_GROUPING_PRESETS in Task 8.4) */
export const STORAGE_KEY_CUSTOM_PRESETS = 'lgm_products_custom_presets';
/** Canonical user-saved grouping presets key (used from Task 8.4 onward) */
export const STORAGE_KEY_GROUPING_PRESETS = 'lgm_grouping_presets';

// --- Filters ---
/** User-saved filter presets */
export const STORAGE_KEY_FILTER_PRESETS = 'lgm_filter_presets';
/** Active filter preset name */
export const STORAGE_KEY_FILTER_ACTIVE = 'lgm_filter_active_preset';

// --- Column visibility & order ---
/** Column visibility model (Record<string, boolean>) */
export const STORAGE_KEY_COLUMN_VISIBILITY = 'lgm_products_column_visibility';
/** Column order (string[]) */
export const STORAGE_KEY_COLUMN_ORDER = 'lgm_products_column_order';
